import { Skeleton } from '@r/components/ui/skeleton.tsx';
import { Card, CardContent, CardHeader } from '@ui/card.tsx';

const ProductSkeleton = () => (
  <Card className="border-0 rounded-none sm:rounded-3xl sm:max-w-[60vw] sm:mx-auto xl:max-w-none">
    <div className="flex flex-wrap xl:flex-nowrap p-7 space-y-7 xl:space-y-0 xl:space-x-7">
      <div className="w-full xl:w-1/5">
        <Skeleton className="w-2/6 mx-auto aspect-square xl:w-full rounded-2xl" />
      </div>

      <div className="space-y-7 xl:w-4/5">
        <CardHeader className="p-0">
          <Skeleton className="w-3/4 h-8" />
        </CardHeader>

        <CardContent className="p-0 space-y-4">
          <Skeleton className="w-full h-4" />
          <Skeleton className="w-4/5 h-4" />
          <Skeleton className="w-5/6 h-4" />
        </CardContent>
      </div>
    </div>
  </Card>
);

export { ProductSkeleton };
